import React, { useState, useEffect } from "react";
import { api } from "../../../utils/Api";
import { Link, useParams } from "react-router-dom";
import ModalSlidingPane from "./ModalSlidingPane";
import ModalFilePath from "./ModalFilePath";
import ModalAddService from "./ModalAddService";
import ModalCreateRework from "./ModalCreateRework";
import ModalUpdateService from "./ModalUpdateService";
import ModalRework from "./ModalRework";
import { Dropdown } from "bootstrap";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import DeleteAlert from "../../../components/Alert/DeleteAlert";
import ModalTask from "./ModalTask";
import ModalReceipt from "./ModalReceipt";
import ModalInvoice from "./ModalInvoice";
import ModalOtherCharges from "./ModalOtherCharges";

const table_header = [
  {
    name: "Created By",
    width: "20",
  },
  {
    name: "Amount",
    width: "20",
  },
  {
    name: "Notes",
    width: "30",
  },
  {
    name: "Payment Type",
    width: "10",
  },
];

const invoice_table_header = [
  {
    name: "Created By",
    width: "20",
  },
  {
    name: "Amount",
    width: "20",
  },
  {
    name: "Created at",
    width: "30",
  },
  {
    name: "GST Invoice",
    width: "10",
  },
  {
    name: "IGST Invoice",
    width: "10",
  },
];

const other_charges_table_header = [
  {
    name: "Title",
    width: "20",
  },
  {
    name: "Amount",
    width: "20",
  },
  {
    name: "GST Amount",
    width: "20",
  },
  {
    name: "Total Amount",
    width: "20",
  },
  {
    name: "Created By",
    width: "30",
  },
  {
    name: "Created at",
    width: "10",
  },
];

export default function ViewOrder(props: any) {
  const [id_value, SerIdValue] = useState(useParams());
  const [order_details, SetOrderDetails] = useState({});
  const [service_details, SetServicesDetails] = useState([]);
  const [order_id] = useState(useParams());
  const [width, setWidth] = React.useState(window.innerWidth);
  const [state, setState] = useState({
    notesOpen: false,
    fileOpen: false,
    reworkOpen: false,
    data: {
      active_data: [],
      deleted_data: [],
      service_id: null,
      order_id: null,
    },
  });
  const [service_modal, SetServiceModal] = useState({
    is_open: false,
    data: {
      type: "add",
      event_id: null,
      order_id: null,
      company_id: order_details.company_id,
    },
  });
  const [update_service_modal, SetUpdateServiceModal] = useState({
    is_open: false,
    data: {
      order_id: null,
      service_data: [],
    },
  });
  const [create_rework_modal, SetCreateReworkModal] = useState({
    is_open: false,
    data: {
      order_id: null,
      event_id: null,
      service_id: null,
    },
  });
  const [selected_data, SetSelectedData] = useState({
    value: "",
    i: "",
    type: "",
  });
  const [side_open, setSideOpen] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });
  const [delete_modal, SetDeleteModal] = useState({
    is_open: false,
    title: "",
    record: {},
    index: "",
  });
  const [task_modal, SetTaskModal] = useState({
    is_open: false,
    task_data: [],
    index: "",
  });
  const [receipt_modal, SetReceiptModal] = useState({
    is_open: false,
    data: {},
    type: "add",
  });
  const [invoice_modal, SetInvoiceModal] = useState({
    is_open: false,
    data: {},
    type: "add",
  });
  const [other_charges_modal, SetOtherChargesModal] = useState({
    is_open: false,
    data: {},
    type: "add",
  });
  const [receipt_data, SetReceiptData] = useState([]);
  const [invoice_data, SetInvoiceData] = useState([]);
  const [other_charge_data, SetOtherChargeData] = useState([]);
  const [gst_percent, SetGstPercent] = useState("");
  const [edit_data, SetEditData] = useState({
    is_edit: false,
    value: "",
  });

  function sample_fun(anchor: any, open: any, event: any) {
    console.log("sample_fun anchor :", anchor);
    console.log("sample_fun open :", open);
    console.log("sample_fun event :", event);
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      console.log("return");
      return;
    }
    console.log("toggle else");

    setSideOpen({ ...state, [anchor]: open });
    // toggleDrawer("bottom", true);
  }

  const list = (anchor: any) => (
    <div className="mt-3">
      <div className="d-flex justify-content-center">
        <div className="w-25 px-4">
          <hr className="h-3" />
        </div>
      </div>
      {selected_data.type == "service" ? (
        <ul>
          {/* Notes */}
          <li>
            <div
              className="py-2 cursor"
              onClick={(event) => {
                setState((oldValues: any) => ({
                  ...oldValues,
                  notesOpen: true,
                  data: {
                    // active_data: service.notes,
                    active_data: selected_data.value.hasOwnProperty("notes")
                      ? selected_data.value.notes
                      : [],
                    deleted_data: selected_data.value.hasOwnProperty(
                      "deleted_notes"
                    )
                      ? selected_data.value.deleted_notes
                      : [],
                    service_id: selected_data.value.id,
                    order_id: id_value.order_id,
                  },
                }));
                sample_fun("bottom", false, event);
              }}
            >
              <img
                src={require("../../../assets/icon/svg/clipboard1.svg")}
                className="action_menu_img cursor"
              />
              &nbsp; Notes
            </div>
          </li>
          {/* RAW Files */}
          <li>
            <div
              className="py-2 cursor"
              onClick={(event) => {
                setState((oldValues: any) => ({
                  ...oldValues,
                  fileOpen: true,
                  data: {
                    // active_data: service.files,
                    active_data: selected_data.value.hasOwnProperty("files")
                      ? selected_data.value.files
                      : [],
                    deleted_data: selected_data.value.hasOwnProperty(
                      "deleted_files"
                    )
                      ? selected_data.value.deleted_files
                      : [],
                    service_id: selected_data.value.id,
                    order_id: id_value.order_id,
                  },
                }));
                sample_fun("bottom", false, event);
              }}
            >
              <img
                src={require("../../../assets/icon/svg/folder1.svg")}
                className="action_menu_img cursor"
              />
              &nbsp; RAW Files
            </div>
          </li>
          {/* Delete */}
          <li>
            {order_details.order_status_id != "2" ? (
              selected_data.value.invoiced == false ? (
                <div
                  className="py-2 cursor"
                  onClick={(event) => {
                    console.log("Delete service");
                    // delete_service(service, s_index);
                    SetDeleteModal((prevValue: any) => {
                      prevValue.is_open = true;
                      prevValue.title = "Service";
                      prevValue.record = selected_data.value;
                      prevValue.index = selected_data.i;
                      return { ...prevValue };
                    });
                    sample_fun("bottom", false, event);
                  }}
                >
                  <img
                    src={require("../../../assets/icon/svg/trash1.svg")}
                    className="action_menu_img cursor"
                  />
                  &nbsp; Delete
                </div>
              ) : null
            ) : null}
          </li>
          {/* Update */}
          <li>
            {order_details.order_status_id != "2" ? (
              selected_data.value.invoiced == false ? (
                <div
                  className="py-2 cursor"
                  onClick={(event) => {
                    console.log("Update service :", selected_data);
                    SetUpdateServiceModal((oldValues: any) => ({
                      ...oldValues,
                      is_open: true,
                      data: {
                        order_id: id_value.order_id,
                        service_data: selected_data.value,
                      },
                    }));
                    sample_fun("bottom", false, event);
                  }}
                >
                  <img
                    src={require("../../../assets/icon/svg/edit3-1.svg")}
                    className="action_menu_img cursor"
                  />
                  &nbsp; Update
                </div>
              ) : null
            ) : null}
          </li>
          {/* Create Rework */}
          <li>
            {order_details.order_status_id != "2" ? (
              <div
                className="py-2 cursor"
                onClick={(event) => {
                  console.log("Create Rework");
                  SetCreateReworkModal((oldValues: any) => ({
                    ...oldValues,
                    is_open: true,
                    data: {
                      order_id: id_value.order_id,
                      event_id: selected_data.value.event_id,
                      service_id: selected_data.value.id,
                    },
                  }));
                  sample_fun("bottom", false, event);
                }}
              >
                <img
                  src={require("../../../assets/icon/svg/plus-square1.svg")}
                  className="action_menu_img cursor"
                />
                &nbsp; Create Rework
              </div>
            ) : null}
          </li>
          {/* Task */}
          <li>
            {selected_data.value.hasOwnProperty("tasks") && (
              <div
                className="py-2 cursor"
                onClick={() => {
                  console.log("Service Task :", selected_data);
                  SetTaskModal((prevValue) => {
                    prevValue.is_open = true;
                    prevValue.task_data = selected_data.value.tasks;
                    prevValue.index = selected_data.i;
                    prevValue.order_status_id = order_details.order_status_id;
                    return { ...prevValue };
                  });
                  sample_fun("bottom", false, event);
                }}
              >
                <img
                  src={require("../../../assets/icon/svg/edit3-1.svg")}
                  className="action_menu_img cursor"
                />
                &nbsp; Task
              </div>
            )}
          </li>
          {/* view rework */}
          <li>
            {selected_data.value.hasOwnProperty("reworks") ? (
              <div
                className="py-2 cursor"
                onClick={() => {
                  console.log("Rework service");
                  setState((oldValues: any) => ({
                    ...oldValues,
                    reworkOpen: true,
                    data: {
                      active_data: selected_data.hasOwnProperty("reworks")
                        ? selected_data.value.reworks
                        : [],
                      deleted_data: selected_data.hasOwnProperty(
                        "deleted_reworks"
                      )
                        ? selected_data.value.deleted_reworks
                        : [],
                      service_id: selected_data.value.id,
                      order_id: id_value.order_id,
                    },
                    order_status_id: order_details.order_status_id,
                  }));
                  sample_fun("bottom", false, event);
                }}
              >
                <i className="far fa-registered"></i>
                &nbsp; View Rework
              </div>
            ) : null}
          </li>
          <div className="pt-3">
            <h6 className="text-gray mb-1 fs-6">-- Status Update --</h6>
          </div>
          {/* Finish Service */}
          {selected_data.value.finished == false &&
          selected_data.value.task_finished == true &&
          selected_data.value.rework_finished == true &&
          (selected_data.value.status_id == "1" ||
            selected_data.value.status_id == "3") ? (
            <li>
              <div
                className="py-2 cursor"
                onClick={() => {
                  console.log("Finish Service");
                  finish_service(selected_data.value);
                }}
              >
                <i className="far fa-registered"></i>
                &nbsp; Finish Service
              </div>
            </li>
          ) : null}

          {!selected_data.value.hasOwnProperty("status_id") ? (
            // {/* Service In Review */}
            selected_data.value.finished == false &&
            selected_data.value.task_finished == true &&
            selected_data.value.rework_finished == true ? (
              <li>
                <div
                  className="py-2 cursor"
                  onClick={() => {
                    console.log("Service In Review");
                    update_service_status(selected_data.value);
                  }}
                >
                  <i className="far fa-registered"></i>
                  &nbsp; Service In Review
                </div>
              </li>
            ) : null
          ) : selected_data.value.status_id == "2" ? (
            // {/* Rework In Review */}
            selected_data.value.finished == false &&
            selected_data.value.task_finished == true &&
            selected_data.value.rework_finished == true ? (
              <li>
                <div
                  className="py-2 cursor"
                  onClick={() => {
                    console.log("Rework In Review");
                    update_rework_status(selected_data.value);
                  }}
                >
                  <i className="far fa-registered"></i>
                  &nbsp; Rework In Review
                </div>
              </li>
            ) : null
          ) : null}

          {/* <li>
            <div
              className="py-2 cursor"
              onClick={(event: any) => {
                console.log("Delete service");
                delete_service(selected_data.value, selected_data.i);
                sample_fun("bottom", false, event);
              }}
            >
              <img
                src={require("../../../assets/icon/svg/trash1.svg")}
                className="action_menu_img cursor"
              />
              &nbsp; Delete
            </div>
          </li>
          <li>
            <div
              className="py-2 cursor"
              onClick={(event) => {
                console.log("Update service");
                SetUpdateServiceModal((oldValues: any) => ({
                  ...oldValues,
                  is_open: true,
                  data: {
                    order_id: id_value.order_id,
                    service_data: selected_data.value,
                  },
                }));
                sample_fun("bottom", false, event);
              }}
            >
              <img
                src={require("../../../assets/icon/svg/edit3-1.svg")}
                className="action_menu_img cursor"
              />
              &nbsp; Update
            </div>
          </li>
          <li>
            <div
              className="py-2 cursor"
              onClick={(event) => {
                console.log("Create Rework");
                SetCreateReworkModal((oldValues: any) => ({
                  ...oldValues,
                  is_open: true,
                  data: {
                    order_id: id_value.order_id,
                    event_id: event.id,
                    service_id: selected_data.value.id,
                  },
                }));
                sample_fun("bottom", false, event);
              }}
            >
              <img
                src={require("../../../assets/icon/svg/plus-square1.svg")}
                className="action_menu_img cursor"
              />
              &nbsp; Create Rework
            </div>
          </li>
          {selected_data.value.status_name == "Rework" ? (
            <li>
              <div
                className="py-2 cursor"
                onClick={(event) => {
                  console.log("Rework service");
                  setState((oldValues: any) => ({
                    ...oldValues,
                    reworkOpen: true,
                    data: {
                      // active_data: service.reworks,
                      active_data: selected_data.value.hasOwnProperty("reworks")
                        ? selected_data.value.reworks
                        : [],
                      deleted_data: selected_data.value.hasOwnProperty(
                        "deleted_rework"
                      )
                        ? selected_data.value.deleted_rework
                        : [],
                      service_id: selected_data.value.id,
                      order_id: id_value.order_id,
                    },
                  }));
                  sample_fun("bottom", false, event);
                }}
              >
                <i className="far fa-registered"></i>
                &nbsp; Rework
              </div>
            </li>
          ) : null} */}
        </ul>
      ) : (
        <div>
          {selected_data.type == "receipt" ? (
            <ul>
              <li>
                <div
                  className="py-2 cursor"
                  onClick={(event) => {
                    SetReceiptModal((prevValue) => {
                      prevValue.is_open = true;
                      prevValue.type = "view";
                      prevValue.data = selected_data.value;

                      return { ...prevValue };
                    });
                    sample_fun("bottom", false, event);
                  }}
                >
                  <img
                    src={require("../../../assets/icon/svg/eye.svg")}
                    className="action_menu_img cursor"
                  />
                  &nbsp; View
                </div>
              </li>
              <li>
                <div
                  className="py-2 cursor"
                  onClick={() => {
                    console.log("Download");
                    sample_fun("bottom", false, event);
                    download_receipt(selected_data.value);
                  }}
                >
                  <img
                    src={require("../../../assets/icon/svg/download1.svg")}
                    className="action_menu_img cursor"
                  />
                  &nbsp; Download
                </div>
              </li>
            </ul>
          ) : (
            <div>
              {selected_data.type == "invoice" ? (
                <ul>
                  <li>
                    <div
                      className="py-2 cursor"
                      onClick={(event) => {
                        SetInvoiceModal((prevValue) => {
                          prevValue.is_open = true;
                          prevValue.type = "view";
                          prevValue.data = selected_data.value;
                          return {
                            ...prevValue,
                          };
                        });
                        sample_fun("bottom", false, event);
                      }}
                    >
                      <img
                        src={require("../../../assets/icon/svg/eye.svg")}
                        className="action_menu_img cursor"
                      />
                      &nbsp; View
                    </div>
                  </li>
                  <li>
                    <div
                      className="py-2 cursor"
                      onClick={(event) => {
                        console.log("Download");
                        sample_fun("bottom", false, event);
                        download_invoice(selected_data.value);
                      }}
                    >
                      <img
                        src={require("../../../assets/icon/svg/download1.svg")}
                        className="action_menu_img cursor"
                      />
                      &nbsp; Download
                    </div>
                  </li>
                </ul>
              ) : (
                <ul>
                  <li>
                    <div
                      className="py-2 cursor"
                      onClick={(event) => {
                        SetOtherChargesModal((prevValue) => {
                          prevValue.is_open = true;
                          prevValue.type = "view";
                          prevValue.data = selected_data.value;

                          return { ...prevValue };
                        });
                        sample_fun("bottom", false, event);
                      }}
                    >
                      <img
                        src={require("../../../assets/icon/svg/eye.svg")}
                        className="action_menu_img cursor"
                      />
                      &nbsp; View
                    </div>
                  </li>
                  <li>
                    <div
                      className="py-2 cursor"
                      onClick={(event) => {
                        console.log("Download");
                        sample_fun("bottom", false, event);
                        SetDeleteModal((prevValue: any) => {
                          prevValue.is_open = true;
                          prevValue.title = "Other Charges";
                          prevValue.record = selected_data.value;
                          prevValue.index = selected_data.i;
                          return { ...prevValue };
                        });
                      }}
                    >
                      <img
                        src={require("../../../assets/icon/svg/trash1.svg")}
                        className="action_menu_img cursor"
                      />
                      &nbsp; Delete
                    </div>
                  </li>
                </ul>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );

  useEffect(() => {
    console.log("Order id:", order_id);
    get_order_details();
    get_order_receipts();
    get_order_invoices();
  }, []);

  async function get_order_details() {
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        order_id: id_value.order_id,
      },
    };
    let data = await api("/outlet/order_details_v2", pass_data);
    console.log("order_details_v2 response :", data);
    if (data.response.hasOwnProperty("orders")) {
      SetOrderDetails(data.response.orders);
    }
    if (data.response.hasOwnProperty("order_services")) {
      SetServicesDetails(data.response.order_services);
    }
    if (data.response.hasOwnProperty("order_other_charges")) {
      SetOtherChargeData(data.response.order_other_charges);
    }
    if (data.response.hasOwnProperty("settings")) {
      SetGstPercent(data.response.settings.gst_percent);
    }
  }

  async function get_order_receipts() {
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        order_id: id_value.order_id,
      },
    };
    let data = await api("/outlet/order_receipts", pass_data);
    console.log("order_receipts response :", data);
    if (data.response.hasOwnProperty("receipts")) {
      SetReceiptData(data.response.receipts);
    }
  }

  async function get_order_invoices() {
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        order_id: id_value.order_id,
      },
    };
    let data = await api("/outlet/order_invoices", pass_data);
    console.log("order_invoices response :", data);
    if (data.response.hasOwnProperty("invoices")) {
      SetInvoiceData(data.response.invoices);
    }
  }

  function PanalClose(data: any, type: string) {
    console.log("panel note close:", data);
    if (type == "notes") {
      setState((oldValues) => ({
        ...oldValues,
        notesOpen: false,
        data: {
          active_data: [],
          deleted_data: [],
          service_id: null,
          order_id: null,
        },
      }));
    } else {
      setState((oldValues) => ({
        ...oldValues,
        fileOpen: false,
        data: {
          active_data: [],
          deleted_data: [],
          service_id: null,
          order_id: null,
        },
      }));
    }
  }

  async function delete_service(service_data: any, service_index: number) {
    console.log("service data :", service_data);
    console.log("service index :", service_index);
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        order_id: id_value.order_id,
      },
      post: {
        service_id: service_data.id,
      },
    };
    let res = await api("/outlet/delete_order_service", pass_data);
    console.log("delete_order_service res :", res);
    // if (res.response.hasOwnProperty("order_services")) {
    SetServicesDetails(res.response.order_services);
    // }
  }

  async function delete_other_charges(
    other_charges_data: any,
    other_charges_index: number
  ) {
    console.log("other_charges data :", other_charges_data);
    console.log("other_charges index :", other_charges_index);
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        order_id: id_value.order_id,
      },
      post: {
        charge_id: other_charges_data.id,
      },
    };
    let res = await api("/outlet/delete_other_charge", pass_data);
    console.log("delete_other_charge res :", res);

    if (res.response.hasOwnProperty("orders")) {
      SetOrderDetails(res.response.orders);
    }
    if (res.response.hasOwnProperty("order_services")) {
      SetServicesDetails(res.response.order_services);
    }
    if (res.response.hasOwnProperty("order_other_charges")) {
      SetOtherChargeData(res.response.order_other_charges);
    }
  }

  function service_modal_on_close(data: any) {
    console.log("service_modal_on_close :", data);
    SetServiceModal((oldValues) => ({
      ...oldValues,
      is_open: false,
    }));
    if (data.action == "save") {
      SetServicesDetails(data.service_data);
      get_order_details();
    }
  }

  function rework_modal_on_close(data: any) {
    console.log("rework_modal_on_close :", data);
    SetCreateReworkModal((oldValues) => ({
      ...oldValues,
      is_open: false,
    }));
    if (data.action == "save") {
      SetServicesDetails(data.service_data);
    }
  }

  function ReworkClose(data: any) {
    console.log("Rework close: ", data);
    setState((oldValues) => ({
      ...oldValues,
      reworkOpen: false,
      data: {
        active_data: [],
        deleted_data: [],
        service_id: null,
        order_id: null,
      },
    }));
    if (data.action == "save") {
      SetServicesDetails(data.service_data);
    }
    if (data.action == "reload") {
      get_order_details();
      get_order_receipts();
    }
  }

  async function finish_order(status_id_value: any) {
    console.log("Finish order");
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        order_id: id_value.order_id,
      },
      post: {
        status_id: status_id_value,
      },
    };
    let res = await api("/outlet/update_order_status", pass_data);
    console.log("update_order_status res :", res);
    if (res.response.hasOwnProperty("status")) {
      if (res.response.status) {
        get_order_details();
        get_order_receipts();
      }
    }
  }

  async function finish_service(service_data: any) {
    console.log("Finish Service");
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        order_id: id_value.order_id,
      },
      post: {
        service_id: service_data.id,
      },
    };
    let res = await api("/outlet/finish_service", pass_data);
    console.log("finish_service res :", res);
    if (res.response.hasOwnProperty("status")) {
      if (res.response.status) {
        get_order_details();
        get_order_receipts();
      }
    }
  }

  async function download_receipt(r_data: any) {
    console.log("Download receipt: ", r_data);
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        receipt_id: r_data.id,
      },
    };
    let res = await api("/outlet/download_order_receipt", pass_data, true);
    console.log("download_order_receipt res :", res.response);

    const url = window.URL.createObjectURL(new Blob([res.response]));
    const link = document.createElement("a");
    link.href = url;
    let file_name = "Receipt_" + r_data.id + ".pdf";
    link.setAttribute("download", file_name);
    document.body.appendChild(link);
    link.click();
  }

  async function download_invoice(i_data: any) {
    console.log("download_invoice :", i_data);
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        invoice_id: i_data.id,
      },
    };
    let res = await api("/outlet/download_order_invoice", pass_data, true);
    console.log("download_order_invoice res :", res.response);

    const url = window.URL.createObjectURL(new Blob([res.response]));
    const link = document.createElement("a");
    link.href = url;
    let file_name = "Invoice_" + i_data.id + ".pdf";
    link.setAttribute("download", file_name);
    document.body.appendChild(link);
    link.click();
  }

  async function update_service_status(service_data: any) {
    console.log("update_service_status");
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        order_id: id_value.order_id,
      },
      post: {
        service_id: service_data.id,
        status_id: 1,
      },
    };
    let res = await api("/outlet/update_service_status", pass_data);
    console.log("update_service_status res :", res);
    if (res.response.hasOwnProperty("status")) {
      if (res.response.status) {
        get_order_details();
        get_order_receipts();
      }
    }
  }

  async function update_rework_status(service_data: any) {
    console.log("update_rework_status");
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        order_id: id_value.order_id,
      },
      post: {
        service_id: service_data.id,
        status_id: 3,
      },
    };
    let res = await api("/outlet/update_service_status", pass_data);
    console.log("update_service_status res :", res);
    if (res.response.hasOwnProperty("status")) {
      if (res.response.status) {
        get_order_details();
        get_order_receipts();
      }
    }
  }

  async function update_order_details() {
    console.log("update_order_details");
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        order_id: id_value.order_id,
      },
      post: {
        client_name: edit_data.value,
      },
    };
    let res = await api("/outlet/update_order_details", pass_data);
    console.log("update_order_details res :", res);
    if (res.response.hasOwnProperty("orders")) {
      get_order_details();
      get_order_receipts();
      SetEditData((prevValue) => {
        prevValue.is_edit = false;
        prevValue.value = "";
        return { ...prevValue };
      });
    }
  }

  return (
    <div>
      <div className="bg-fff py-3 px-4">
        <div className="pb-2 d-flex align-items-center">
          <div
            onClick={() => {
              window.history.back();
            }}
          >
            <img
              src={require("../../../assets/icon/svg/arrow-left.svg")}
              className="action-img"
            />
          </div>
          <h5 className="  mb-0 ps-2 text-dark fw-bolder">Order Details</h5>
          {/* <p className="v-small mb-0">500+ orders</p> */}
        </div>
      </div>

      <div className="container mb-3">
        <div className="card mt-2 p-3">
          <div className="row">
            <div className="col-md-6">
              <h5 className="  ">{order_details.company_name}</h5>
              <div className="">
                {!edit_data.is_edit ? (
                  <p className="pt-2">
                    <img
                      src={require("../../../assets/icon/svg/user1.svg")}
                      className="pe-2 order-icon"
                    />
                    {order_details.client_name}
                    <img
                      src={require("../../../assets/icon/svg/edit3-1.svg")}
                      className="action_menu_img cursor m-2"
                      onClick={() => {
                        SetEditData((prevValue) => {
                          prevValue.is_edit = true;
                          prevValue.value = order_details.client_name;
                          return { ...prevValue };
                        });
                      }}
                    />
                  </p>
                ) : (
                  <p className="pt-2">
                    <img
                      src={require("../../../assets/icon/svg/user1.svg")}
                      className="pe-2 order-icon"
                    />
                    <input
                      value={edit_data.value}
                      onChange={(e) => {
                        SetEditData((prevValue) => {
                          prevValue.value = e.target.value;
                          return { ...prevValue };
                        });
                      }}
                    />
                    <button
                      className="btn btn-light-outline btn-sm m-2"
                      onClick={() => {
                        SetEditData((prevValue) => {
                          prevValue.is_edit = false;
                          return { ...prevValue };
                        });
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-light-outline btn-sm m-2"
                      onClick={() => {
                        // SetEditData((prevValue) => {
                        //   prevValue.is_edit = false;
                        //   return { ...prevValue };
                        // });
                        if (edit_data.value != "") {
                          console.log("update");
                          update_order_details();
                          // SetEditData((prevValue) => {
                          //   prevValue.is_edit = false;
                          //   return { ...prevValue };
                          // });
                        }
                      }}
                    >
                      Update
                    </button>
                  </p>
                )}
              </div>

              <p className="">
                <img
                  src={require("../../../assets/icon/svg/mail1.svg")}
                  className="pe-2 order-icon"
                />
                {order_details.company_email}
              </p>
              <p>
                <img
                  src={require("../../../assets/icon/svg/map-pin1.svg")}
                  className="pe-2 order-icon"
                />
                {order_details.company_address}
              </p>
            </div>
            <div className="col-md-6 sm-left text-end">
              <small>
                <img
                  src={require("../../../assets/icon/svg/clock1.svg")}
                  className="pe-2 order-icon"
                />
                <span className="ps-2 text-dark">
                  {order_details.created_at}
                </span>
              </small>

              <h6 className="pt-3 m-0 pb-3">
                <b className="text-green">{order_details.order_status}</b>
              </h6>

              <div className="d-flex sm-left justify-content-end">
                <p className="pe-3">
                  <i className="fas fa-mobile-alt pe-2"></i>
                  {order_details.company_mobile}
                </p>
                <p>
                  <i className="fab fa-whatsapp pe-2"></i>
                  {order_details.company_whatsapp}
                </p>
              </div>

              <div className="d-flex sm-left justify-content-end">
                {order_details.services_finished &&
                order_details.order_status_id != "2" &&
                order_details.pending_amount == 0 ? (
                  <button
                    className="btn btn-light-outline"
                    onClick={() => {
                      finish_order(2);
                    }}
                  >
                    Finish Order
                  </button>
                ) : null}
              </div>
              {order_details.order_status_id == "1" ? (
                <div className="d-flex sm-left justify-content-end">
                  <button
                    className="btn btn-light-outline btn-sm"
                    onClick={() => {
                      finish_order(3);
                    }}
                  >
                    Cancel Order
                  </button>
                </div>
              ) : null}
            </div>
          </div>
        </div>

        {/* Amount cards */}
        <div className="row pt-3 pb-2">
          <div className="col-lg-2 col-sm-3 col-6 mb-2">
            <div className="card p-3">
              <h6 className="text-gray fs-6 aHeight">Total Amount</h6>
              <p className="mb-0">
                <b className="text-dark fs-6">₹ {order_details.total_amount}</b>
              </p>
            </div>
          </div>

          <div className="col-lg-2 col-sm-3 col-6 mb-2">
            <div className="card p-3">
              <h6 className="text-gray fs-6 aHeight">Paid Amount</h6>
              <p className="mb-0">
                <b className="text-dark fs-6">₹ {order_details.paid_amount}</b>
              </p>
            </div>
          </div>

          <div className="col-lg-2 col-sm-3 col-6 mb-2">
            <div className="card p-3">
              <h6 className="text-gray fs-6 aHeight">Pending Amount</h6>
              <p className="mb-0">
                <b className="text-dark fs-6">
                  ₹ {order_details.pending_amount}
                </b>
              </p>
            </div>
          </div>

          <div className="col-lg-2 col-sm-3 col-6 mb-2">
            <div className="card p-3">
              <h6 className="text-gray fs-6 aHeight">Invoiced Amount</h6>
              <p className="mb-0">
                <b className="text-dark fs-6">
                  ₹ {order_details.total_invoiced_amount}
                </b>
              </p>
            </div>
          </div>

          <div className="col-lg-2 col-sm-3 col-6 mb-2">
            <div className="card p-3">
              <h6 className="text-gray fs-6 aHeight">
                Invoiced Pending Amount
              </h6>
              <p className="mb-0">
                <b className="text-dark fs-6">
                  ₹ {order_details.total_invoice_pending_amount}
                </b>
              </p>
            </div>
          </div>
        </div>

        <div className="row">
          {/* Event Service Tab */}
          <div className="col-lg-6">
            <div className="card mb-2 p-3 ">
              <div className="d-flex pb-3">
                <h6 className="fw-bold">Service Details</h6>
                <div className="ms-auto">
                  {order_details.order_status_id == "1" ? (
                    <button
                      className="btn btn-sm btn-light-outline"
                      onClick={() => {
                        console.log("add service");
                        SetServiceModal((oldValues: any) => ({
                          ...oldValues,
                          is_open: true,
                          data: {
                            ...oldValues.data,
                            type: "add",
                            order_id: id_value.order_id,
                            company_id: order_details.company_id,
                          },
                        }));
                      }}
                    >
                      Add Services
                    </button>
                  ) : null}
                </div>
              </div>
              <div className="row users_scroll">
                {service_details?.map((s_ele: any, s_index: any) => (
                  <div
                    className="border-bottom p-2 my-2"
                    key={s_index}
                    onClick={() => {
                      if (width < 768) {
                        console.log("width", width);
                        SetSelectedData({
                          value: s_ele,
                          i: s_index,
                          type: "service",
                        });

                        // sample_fun("bottom", true, event);
                        sample_fun("bottom", true, s_ele);
                      }
                    }}
                  >
                    <div className="row p-2">
                      <div className="col-11">
                        <p className="m-0 text-dark fw-bold">
                          {s_ele.service_name}
                        </p>
                        <small>
                          {s_ele.service_quantity_type == "1" ? (
                            <span>Item Wise</span>
                          ) : (
                            <span>Duration Wise</span>
                          )}
                        </small>
                      </div>
                      <div className="col-1 text-end d-md-block d-sm-none">
                        <div className="dropdown">
                          <div
                            id="dropdownMenuButton1"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <img
                              src={require("../../../assets/icon/svg/more-horizontal.svg")}
                              className="action_img cursor"
                            />
                          </div>
                          <ul
                            className="dropdown-menu"
                            aria-labelledby="dropdownMenuButton2"
                          >
                            {/* Notes */}
                            <li>
                              <div
                                className="dropdown-item cursor"
                                onClick={() => {
                                  console.log("Notes");
                                  setState((oldValues: any) => ({
                                    ...oldValues,
                                    notesOpen: true,
                                    data: {
                                      active_data: s_ele.hasOwnProperty("notes")
                                        ? s_ele.notes
                                        : [],
                                      deleted_data: s_ele.hasOwnProperty(
                                        "deleted_notes"
                                      )
                                        ? s_ele.deleted_notes
                                        : [],
                                      service_id: s_ele.id,
                                      order_id: id_value.order_id,
                                    },
                                    order_status_id:
                                      order_details.order_status_id,
                                  }));
                                }}
                              >
                                <img
                                  src={require("../../../assets/icon/svg/clipboard1.svg")}
                                  className="action_menu_img cursor"
                                />
                                &nbsp; Notes
                              </div>
                            </li>

                            {/* RAW Files */}
                            <li>
                              <div
                                className="dropdown-item cursor"
                                onClick={() => {
                                  console.log("Files");
                                  setState((oldValues: any) => ({
                                    ...oldValues,
                                    fileOpen: true,
                                    data: {
                                      active_data: s_ele.hasOwnProperty("files")
                                        ? s_ele.files
                                        : [],
                                      deleted_data: s_ele.hasOwnProperty(
                                        "deleted_files"
                                      )
                                        ? s_ele.deleted_files
                                        : [],
                                      service_id: s_ele.id,
                                      order_id: id_value.order_id,
                                    },
                                    order_status_id:
                                      order_details.order_status_id,
                                  }));
                                }}
                              >
                                <img
                                  src={require("../../../assets/icon/svg/folder1.svg")}
                                  className="action_menu_img cursor"
                                />
                                &nbsp; RAW Files
                              </div>
                            </li>

                            {/* Delete */}
                            {order_details.order_status_id != "2" ? (
                              s_ele.invoiced == false ? (
                                <li>
                                  <div
                                    className="dropdown-item cursor"
                                    onClick={() => {
                                      console.log("Delete service");
                                      // delete_service(service, s_index);
                                      SetDeleteModal((prevValue: any) => {
                                        prevValue.is_open = true;
                                        prevValue.title = "Service";
                                        prevValue.record = s_ele;
                                        prevValue.index = s_index;
                                        return { ...prevValue };
                                      });
                                    }}
                                  >
                                    <img
                                      src={require("../../../assets/icon/svg/trash1.svg")}
                                      className="action_menu_img cursor"
                                    />
                                    &nbsp; Delete
                                  </div>
                                </li>
                              ) : null
                            ) : null}

                            {/* Update */}
                            {order_details.order_status_id != "2" ? (
                              s_ele.invoiced == false ? (
                                <li>
                                  <div
                                    className="dropdown-item cursor"
                                    onClick={() => {
                                      console.log("Update service :", s_ele);
                                      SetUpdateServiceModal(
                                        (oldValues: any) => ({
                                          ...oldValues,
                                          is_open: true,
                                          data: {
                                            order_id: id_value.order_id,
                                            service_data: s_ele,
                                          },
                                        })
                                      );
                                    }}
                                  >
                                    <img
                                      src={require("../../../assets/icon/svg/edit3-1.svg")}
                                      className="action_menu_img cursor"
                                    />
                                    &nbsp; Update
                                  </div>
                                </li>
                              ) : null
                            ) : null}

                            {/* Create Rework */}
                            {order_details.order_status_id == "1" ? (
                              s_ele.hasOwnProperty("status_id") ? (
                                s_ele.status_id == "1" ||
                                s_ele.status_id == "3" ? (
                                  !s_ele.finished && s_ele.task_finished ? (
                                    <li>
                                      <div
                                        className="dropdown-item cursor"
                                        onClick={() => {
                                          console.log("Create Rework");
                                          SetCreateReworkModal(
                                            (oldValues: any) => ({
                                              ...oldValues,
                                              is_open: true,
                                              data: {
                                                order_id: id_value.order_id,
                                                event_id: s_ele.event_id,
                                                service_id: s_ele.id,
                                              },
                                            })
                                          );
                                        }}
                                      >
                                        <img
                                          src={require("../../../assets/icon/svg/plus-square1.svg")}
                                          className="action_menu_img cursor"
                                        />
                                        &nbsp; Create Rework
                                      </div>
                                    </li>
                                  ) : null
                                ) : null
                              ) : null
                            ) : null}

                            {/* Task */}
                            {s_ele.hasOwnProperty("tasks") && (
                              <li>
                                <div
                                  className="dropdown-item cursor"
                                  onClick={() => {
                                    console.log("Service Task :", s_ele);
                                    SetTaskModal((prevValue) => {
                                      prevValue.is_open = true;
                                      prevValue.task_data = s_ele.tasks;
                                      prevValue.index = s_index;
                                      prevValue.order_status_id =
                                        order_details.order_status_id;
                                      return { ...prevValue };
                                    });
                                  }}
                                >
                                  <img
                                    src={require("../../../assets/icon/svg/edit3-1.svg")}
                                    className="action_menu_img cursor"
                                  />
                                  &nbsp; Task
                                </div>
                              </li>
                            )}

                            {/* view rework */}
                            {s_ele.hasOwnProperty("reworks") ||
                            s_ele.hasOwnProperty("deleted_reworks") ? (
                              <li>
                                <div
                                  className="dropdown-item cursor"
                                  onClick={() => {
                                    console.log("Rework service");
                                    setState((oldValues: any) => ({
                                      ...oldValues,
                                      reworkOpen: true,
                                      data: {
                                        active_data: s_ele.hasOwnProperty(
                                          "reworks"
                                        )
                                          ? s_ele.reworks
                                          : [],
                                        deleted_data: s_ele.hasOwnProperty(
                                          "deleted_reworks"
                                        )
                                          ? s_ele.deleted_reworks
                                          : [],
                                        service_id: s_ele.id,
                                        order_id: id_value.order_id,
                                      },
                                      order_status_id:
                                        order_details.order_status_id,
                                    }));
                                  }}
                                >
                                  <i className="far fa-registered"></i>
                                  &nbsp; View Rework
                                </div>
                              </li>
                            ) : null}

                            <div className="mt-3 text-center">
                              <h6 className="text-gray mb-2 fs-6">
                                -- Status Update --
                              </h6>
                            </div>

                            {/* Finish Service */}
                            {s_ele.finished == false &&
                            s_ele.task_finished == true &&
                            s_ele.rework_finished == true &&
                            (s_ele.status_id == "1" ||
                              s_ele.status_id == "3") ? (
                              <li>
                                <div
                                  className="dropdown-item cursor"
                                  onClick={() => {
                                    console.log("Finish Service");
                                    finish_service(s_ele);
                                  }}
                                >
                                  <i className="far fa-registered"></i>
                                  &nbsp; Finish Service
                                </div>
                              </li>
                            ) : null}

                            {!s_ele.hasOwnProperty("status_id") ? (
                              // {/* Service In Review */}
                              s_ele.finished == false &&
                              s_ele.task_finished == true &&
                              s_ele.rework_finished == true ? (
                                <li>
                                  <div
                                    className="dropdown-item cursor"
                                    onClick={() => {
                                      console.log("Service In Review");
                                      update_service_status(s_ele);
                                    }}
                                  >
                                    <i className="far fa-registered"></i>
                                    &nbsp; Service In Review
                                  </div>
                                </li>
                              ) : null
                            ) : s_ele.status_id == "2" ? (
                              // {/* Rework In Review */}
                              s_ele.finished == false &&
                              s_ele.task_finished == true &&
                              s_ele.rework_finished == true ? (
                                <li>
                                  <div
                                    className="dropdown-item cursor"
                                    onClick={() => {
                                      console.log("Rework In Review");
                                      update_rework_status(s_ele);
                                    }}
                                  >
                                    <i className="far fa-registered"></i>
                                    &nbsp; Rework In Review
                                  </div>
                                </li>
                              ) : null
                            ) : null}
                          </ul>
                        </div>
                      </div>

                      <div className="col-6 mt-1">
                        <div className="d-flex align-items-center">
                          <img
                            src={require("../../../assets/icon/svg/calendar1.svg")}
                            className="action_img pe-2"
                          />
                          <p className="m-0 text-gray">{s_ele.event_name}</p>
                        </div>
                      </div>

                      <div className="col-6 text-end">
                        <p className="text-green fw-600 pt-1 mb-0">
                          {/* {s_ele.status_name} */}
                          {s_ele.invoiced ? "Invoiced" : ""}
                        </p>
                      </div>

                      {s_ele.price != null ? (
                        <div className="row pe-0">
                          <div className="col-md-4 col-4 pt-2 d-flex align-items-center">
                            <p className="text-gray fs-6 fw-600 m-0">Qty :</p>
                            <p className="ps-2 mb-0 text-dark">
                              {s_ele.price.quantity}
                            </p>
                          </div>
                          {/* <div className="col-md-2 col-6 pt-2 pe-0 d-flex align-items-center justify-content-end">
                            <p className="text-gray fs-6 fw-600 m-0">GST :</p>
                            <p className="ps-2 mb-0 text-dark">
                              ₹ {s_ele.price.gst_amount}
                              <small className="ps-1 text-gray">[{s_ele.price.gst_percent} %]</small>
                            </p>
                          </div> */}
                          <div className="col-md-8 col-8 justify-content-end pt-2 pe-0 d-flex align-items-center">
                            <p className="text-gray mb-0 fs-6 fw-600-0">
                              Total :
                            </p>
                            <p className="ps-2 mb-0 text-dark">
                              ₹{" "}
                              {parseFloat(s_ele.price.total_amount).toFixed(2)}
                            </p>
                          </div>
                          {/* {s_ele.finished == false &&
                            s_ele.task_finished == true &&
                            s_ele.rework_finished == true ? (
                              <div className="col-md-4 col-4 pt-2 d-flex align-items-center">
                                <button
                                  className="btn btn-light-outline"
                                  onClick={() => {
                                    console.log("Update Status");
                                    update_service_status(s_ele);
                                  }}
                                >
                                  Update Status
                                </button>
                              </div>
                            ) : null} */}
                        </div>
                      ) : null}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Other Charges */}
          <div className="col-lg-6">
            <div className="card mb-2 p-3">
              <div className="d-flex align-items-center pb-3">
                <h6>Other Charges</h6>
                <div className="ms-auto">
                  {order_details.order_status_id == "1" ? (
                    <button
                      className="btn btn-sm btn-light-outline"
                      onClick={() => {
                        console.log("Other Charges add");
                        SetOtherChargesModal((prevValue) => {
                          prevValue.is_open = true;
                          prevValue.type = "add";
                          return { ...prevValue };
                        });
                      }}
                    >
                      <img
                        src={require("../../../assets/icon/svg/plus1.svg")}
                        className="pe-2"
                      />
                      Add
                    </button>
                  ) : null}
                </div>
              </div>
              <div className="users_scroll">
                {other_charge_data.length > 0 ? (
                  <div>
                    {other_charge_data.map((data, r_index) => (
                      <div
                        className="row border-bottom py-2"
                        key={r_index}
                        onClick={(event) => {
                          if (width < 768) {
                            sample_fun("bottom", true, event);
                            SetSelectedData({
                              value: data,
                              i: r_index,
                              type: "other_charges",
                            });
                          }
                        }}
                      >
                        <div className="row mt-2 pe-0">
                          <div className="col-4">
                            <p className="mb-2">{data.title}</p>
                          </div>
                          <div className="col-8 text-end">
                            <small className="mb-2 text-gray">
                              {data.created_at}
                            </small>
                          </div>

                          <div className="col-11 mb-2">
                            <h6 className="mb-1 text-dark fs-6">
                              {data.created_user}
                            </h6>
                            <p className="v-small mb-1">
                              @{data.created_username}
                            </p>
                          </div>
                          <div className="col-1">
                            <div className="dropdown cursor d-md-block d-sm-none">
                              <div
                                id="dropdownMenuButton1"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <img
                                  src={require("../../../assets/icon/svg/more-horizontal.svg")}
                                  className="action_img cursor"
                                />
                              </div>
                              <ul
                                className="dropdown-menu"
                                aria-labelledby="dropdownMenuButton2"
                              >
                                {/* View */}
                                <li>
                                  <div
                                    onClick={() => {
                                      console.log("view");

                                      SetOtherChargesModal((prevValue) => {
                                        prevValue.is_open = true;
                                        prevValue.type = "view";
                                        prevValue.data = data;

                                        return { ...prevValue };
                                      });
                                    }}
                                    className="dropdown-item"
                                  >
                                    <img
                                      src={require("../../../assets/icon/svg/eye.svg")}
                                      className="action_menu_img cursor"
                                    />
                                    &nbsp; View
                                  </div>
                                </li>
                                {/* Delete */}
                                <li>
                                  <div
                                    onClick={() => {
                                      console.log("Delete");
                                      SetDeleteModal((prevValue: any) => {
                                        prevValue.is_open = true;
                                        prevValue.title = "Other Charges";
                                        prevValue.record = data;
                                        prevValue.index = i_index;
                                        return { ...prevValue };
                                      });
                                    }}
                                    className="dropdown-item"
                                  >
                                    <img
                                      src={require("../../../assets/icon/svg/trash1.svg")}
                                      className="action_menu_img cursor"
                                    />
                                    &nbsp; Delete
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </div>

                          <div className="col-6">
                            <p className="mb-2">
                              <b>Amount : ₹{data.amount}</b>
                            </p>
                          </div>
                          <div className="col-6 text-end">
                            {data.gst_amount == null ? (
                              <p className="mb-2 ">
                                <b>GST : ₹0</b>
                              </p>
                            ) : (
                              <p className="mb-2 ">
                                <b>GST : ₹{data.gst_amount}</b>
                              </p>
                            )}
                          </div>
                          <div className="col-12 text-end ">
                            <h6 className="mb-1 fs-6">
                              Total Amount : ₹{data.total_amount}
                            </h6>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="text-center">
                    <img
                      src={require("../../../assets/img/svg/no_data_2.svg")}
                      className="w-30 pb-2"
                    />
                    <p className="v-small mb-0">
                      No Data, Please Add Other Charges
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Invoice */}
          <div className="col-lg-6">
            <div className="card mt-2 p-3 col-12">
              <div className="d-flex align-items-center pb-3">
                <h5>Invoice</h5>
                <button
                  className="btn btn-light-outline ms-auto align-items-center btn-sm"
                  onClick={() => {
                    console.log("invoice add");
                    SetInvoiceModal((prevValue) => {
                      prevValue.is_open = true;
                      prevValue.type = "add";
                      return { ...prevValue };
                    });
                  }}
                >
                  <img
                    src={require("../../../assets/icon/svg/plus1.svg")}
                    className="pe-2"
                  />
                  Add
                </button>
              </div>
              <div className="users_scroll">
                {invoice_data.length > 0 ? (
                  invoice_data.map((data, r_index) => (
                    <div
                      className="row border-bottom py-2"
                      key={r_index}
                      onClick={(event) => {
                        if (width < 768) {
                          sample_fun("bottom", true, event);
                          SetSelectedData({
                            value: data,
                            i: r_index,
                            type: "invoice",
                          });
                        }
                      }}
                    >
                      <div className="col-12 col-md-11">
                        <h6 className="mb-1 text-dark">{data.created_user}</h6>
                      </div>
                      <div className="col-md-1 d-md-block d-sm-none">
                        <div className="dropdown cursor">
                          <div
                            id="dropdownMenuButton1"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <img
                              src={require("../../../assets/icon/svg/more-horizontal.svg")}
                              className="action_img cursor"
                            />
                          </div>
                          <ul
                            className="dropdown-menu"
                            aria-labelledby="dropdownMenuButton2"
                          >
                            {/* View */}
                            <li>
                              <div
                                onClick={() => {
                                  console.log("view");

                                  SetInvoiceModal((prevValue) => {
                                    prevValue.is_open = true;
                                    prevValue.type = "view";
                                    prevValue.data = data;
                                    return {
                                      ...prevValue,
                                    };
                                  });
                                }}
                                className="dropdown-item"
                              >
                                <img
                                  src={require("../../../assets/icon/svg/eye.svg")}
                                  className="action_menu_img cursor"
                                />
                                &nbsp; View
                              </div>
                            </li>
                            {/* Download */}
                            <li>
                              {/* <div
                                onClick={() => {
                                  console.log("Download");
                                  download_invoice(data);
                                }}
                                className="dropdown-item"
                              >
                                <img
                                  src={require("../../../assets/icon/svg/download1.svg")}
                                  className="action_menu_img cursor"
                                />
                                &nbsp; Download
                              </div> */}
                              <div className="dropdown-item">
                                <a
                                  href={
                                    "https://postproduction.1superapp.com/app/outlet/download_order_invoice?brand=" +
                                    id_value.brand_id +
                                    "&outlet=" +
                                    id_value.outlet_id +
                                    "&invoice_id=" +
                                    data.id
                                  }
                                >
                                  Download
                                </a>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="col-8 mb-2">
                        <p className="v-small mb-1">@{data.created_username}</p>
                      </div>
                      <div className="col-4 text-end mb-2">
                        <small className="mb-1 text-gray ">
                          {data.invoice_timestamp}
                        </small>
                      </div>

                      <div className="col-4 pe-0">
                        <h6 className="mb-1 fs-6">₹ {data.amount}</h6>
                      </div>
                      <div className="col-4">
                        <p className="mb-1">
                          GST : {data.gst_invoice ? "Yes" : "No"}
                        </p>
                      </div>
                      <div className="col-4 text-end">
                        <p className="mb-1 ms-auto">
                          IGST : {data.igst_invoice ? "Yes" : "No"}
                        </p>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="text-center">
                    <img
                      src={require("../../../assets/img/svg/no_data_2.svg")}
                      className="w-30 pb-2"
                    />
                    <p className="v-small mb-0">
                      No Data, Please Add Other Charges
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Receipts */}
          <div className="col-lg-6">
            <div className="card mt-2 p-3 col-12">
              <div className="d-flex align-items-center mb-3">
                <h5>Receipts</h5>
                <button
                  className="btn btn-light-outline ms-auto align-items-center btn-sm"
                  onClick={() => {
                    console.log("add");
                    SetReceiptModal((prevValue) => {
                      prevValue.is_open = true;
                      prevValue.type = "add";
                      return { ...prevValue };
                    });
                  }}
                >
                  <img
                    src={require("../../../assets/icon/svg/plus1.svg")}
                    className="pe-2"
                  />
                  Add
                </button>
              </div>
              <div className="users_scroll">
                {receipt_data.length > 0 ? (
                  receipt_data.map((data, r_index) => (
                    <div
                      className="row border-bottom py-2"
                      key={r_index}
                      onClick={(event) => {
                        if (width < 768) {
                          sample_fun("bottom", true, event);
                          SetSelectedData({
                            value: data,
                            i: r_index,
                            type: "receipt",
                          });
                        }
                      }}
                    >
                      <div className="col-md-11">
                        <h6 className="mb-1 fs-6 ">{data.created_user}</h6>
                        <p className="v-small mb-1">@{data.created_username}</p>
                      </div>
                      <div className="col-md-1 d-md-block d-sm-none">
                        <div className="dropdown cursor">
                          <div
                            id="dropdownMenuButton1"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <img
                              src={require("../../../assets/icon/svg/more-horizontal.svg")}
                              className="action_img cursor"
                            />
                          </div>
                          <ul
                            className="dropdown-menu"
                            aria-labelledby="dropdownMenuButton2"
                          >
                            {/* View */}
                            <li>
                              <div
                                onClick={() => {
                                  console.log("view");
                                  SetReceiptModal((prevValue) => {
                                    prevValue.is_open = true;
                                    prevValue.type = "view";
                                    prevValue.data = data;

                                    return { ...prevValue };
                                  });
                                }}
                                className="dropdown-item"
                              >
                                <img
                                  src={require("../../../assets/icon/svg/eye.svg")}
                                  className="action_menu_img cursor"
                                />
                                &nbsp; View
                              </div>
                            </li>
                            {/* Download */}
                            <li>
                              {/* <div
                                onClick={() => {
                                  console.log("Download");
                                  download_receipt(data);
                                }}
                                className="dropdown-item"
                              >
                                <img
                                  src={require("../../../assets/icon/svg/download1.svg")}
                                  className="action_menu_img cursor"
                                />
                                &nbsp; Download
                              </div> */}
                              <div className="dropdown-item">
                                <a
                                  href={
                                    "https://postproduction.1superapp.com/app/outlet/download_order_receipt?brand=" +
                                    id_value.brand_id +
                                    "&outlet=" +
                                    id_value.outlet_id +
                                    "&receipt_id=" +
                                    data.id
                                  }
                                >
                                  Download
                                </a>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div className="row mt-2 pe-0">
                        <div className="col-6 pe-0">
                          <h6 className="mb-1 fs-6 ">₹ {data.amount}</h6>
                        </div>
                        <div className="col-6 text-end">
                          <p className="mb-1 text-dark">{data.payment_type}</p>
                        </div>
                        <div className="col-12">
                          <p className="mb-1 text-gray">{data.notes}</p>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="text-center">
                    <img
                      src={require("../../../assets/img/svg/no_data_2.svg")}
                      className="w-30 pb-2"
                    />
                    <p className="v-small mb-0">
                      No Data, Please Add Other Charges
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <ModalTask
        isOpen={task_modal.is_open}
        task_data={task_modal.task_data}
        index={task_modal.index}
        order_status_id={task_modal.order_status_id}
        close={(data) => {
          SetTaskModal((prevValue) => {
            prevValue.is_open = false;
            return { ...prevValue };
          });
          console.log("modal task on close :", data);
          if (data.action == "save") {
            SetServicesDetails(data.value);
          }
        }}
      />

      <ModalReceipt
        open={receipt_modal.is_open}
        data={receipt_modal.data}
        type={receipt_modal.type}
        total_amount={order_details.total_amount}
        paid_amount={order_details.paid_amount}
        pending_amount={order_details.pending_amount}
        close={(data) => {
          console.log("ModalReceipt on close :", data);
          SetReceiptModal((prevValue) => {
            prevValue.is_open = false;
            return { ...prevValue };
          });
          if (data.action == "save") {
            get_order_receipts();
            get_order_details();
          }
        }}
      />

      <ModalInvoice
        open={invoice_modal.is_open}
        data={invoice_modal.data}
        type={invoice_modal.type}
        close={(data) => {
          console.log("ModalReceipt on close :", data);
          SetInvoiceModal((prevValue) => {
            prevValue.is_open = false;
            return { ...prevValue };
          });
          if (data.action == "get_invoice") {
            get_order_invoices();
          }
        }}
      />

      <ModalOtherCharges
        open={other_charges_modal.is_open}
        data={other_charges_modal.data}
        type={other_charges_modal.type}
        close={(data) => {
          console.log("other_charges_modal on close :", data);
          SetOtherChargesModal((prevValue) => {
            prevValue.is_open = false;
            return { ...prevValue };
          });
          if (data.action == "save") {
            SetOrderDetails(data.value.orders);
            SetServicesDetails(data.value.order_services);
            SetOtherChargeData(data.value.order_other_charges);
          }
        }}
      />

      <DeleteAlert
        open={delete_modal.is_open}
        title={delete_modal.title}
        record={delete_modal.record}
        key={delete_modal.record.id}
        index={delete_modal.index}
        close={(data: any) => {
          SetDeleteModal((prevValue) => {
            prevValue.is_open = false;
            return { ...prevValue };
          });

          if (data.action === "delete") {
            console.log("delete event : ", data);

            if (delete_modal.title == "Other Charges") {
              delete_other_charges(data.value, data.index);
            } else {
              delete_service(data.value, data.index);
            }
          }
        }}
      />

      <ModalSlidingPane
        isOpen={state.notesOpen}
        data={state.data}
        order_status_id={state.order_status_id}
        close={(data: any) => {
          PanalClose(data, "notes");
        }}
      />

      <ModalFilePath
        isOpen={state.fileOpen}
        data={state.data}
        order_status_id={state.order_status_id}
        close={(data: any) => {
          PanalClose(data, "filepath");
        }}
      />

      <ModalAddService
        isOpen={service_modal.is_open}
        data={service_modal.data}
        close={(data: any) => {
          service_modal_on_close(data);
        }}
      />

      <ModalUpdateService
        isOpen={update_service_modal.is_open}
        data={update_service_modal.data}
        gst_percent={gst_percent}
        close={(data: any) => {
          console.log("update_service_modal_on_close :", data);
          SetUpdateServiceModal((oldValues) => ({
            ...oldValues,
            is_open: false,
          }));
          if (data.action == "save") {
            SetServicesDetails(data.service_data);
            get_order_details();
          }
        }}
      />

      <ModalCreateRework
        isOpen={create_rework_modal.is_open}
        data={create_rework_modal.data}
        close={(data: any) => {
          rework_modal_on_close(data);
        }}
      />

      <ModalRework
        isOpen={state.reworkOpen}
        data={state.data}
        order_status_id={state.order_status_id}
        close={(data: any) => {
          // ReworkClose(data, "rework");
          ReworkClose(data);
        }}
      />

      {["left", "right", "top", "bottom"].map((anchor) => (
        <React.Fragment key={anchor}>
          <SwipeableDrawer
            anchor={anchor}
            open={side_open[anchor]}
            onClose={(event) => {
              sample_fun(anchor, false, event);
            }}
            onOpen={(event) => {
              sample_fun(anchor, true, event);
            }}
          >
            {list(anchor)}
          </SwipeableDrawer>
        </React.Fragment>
      ))}
    </div>
  );
}
